import ApiResourceManager from '../ApiResourceManager';

export default class OpenAiManager extends ApiResourceManager {
  generate = (data) =>
    this.request({
      method: 'POST',
      url: '/openai/generate',
      data,
    });
}
